import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-adaf326c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-message-template" }
const _hoisted_2 = { class: "cm-message-header" }
const _hoisted_3 = { class: "cm-message-body" }

import { computed, PropType } from 'vue'
import { i18n } from '@/i18n'
import { Content } from '@/views/_components/message-template/feature-release/feature-release.service'
import { router } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'feature-release',
  props: {
  content: {
    type: Object as PropType<Content>,
    default: () => ({} as any)
  },
  notificationKey: {
    type: String,
  }
},
  emits: ['closeDetails'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const props = __props

const t = i18n.global.t.bind(i18n.global)

const headerText = computed(() =>
  t('messageTemplate.featureRelease.header', { name: props.content.name })
)

function handleLink () {
  emits('closeDetails')
  router.push(props.content.mod_url)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(headerText.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("strong", null, _toDisplayString(__props.content.name), 1),
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.featureRelease.onlinePrefix')) + " ", 1),
      _createElementVNode("strong", null, _toDisplayString(__props.content.description), 1),
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.featureRelease.onlineMiddle')) + " ", 1),
      _createElementVNode("span", {
        class: "cm-link-light underline",
        onClick: handleLink
      }, _toDisplayString(__props.content.mod_name), 1),
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.featureRelease.onlineSuffix')), 1)
    ])
  ]))
}
}

})